<template>
<el-dialog
  :title="item.major_name + '-开设院校'"
  :visible.sync="dialogVisible"
  width="60%" top="2vh">
  <div style="width: 100%;height: 70vh;overflow-y: scroll;">
      <el-form :model="form" :inline="true">
         <el-form-item label="院校名称">
           <el-input placeholder="请输入院校名称" v-model="form.collegeName" clearable @keyup.enter.native="form.page=1,majorCollege()"></el-input>
         </el-form-item>
         <el-form-item label="">
          <el-button type="success" @click="form.page=1,majorCollege()">查询</el-button>
         </el-form-item>
      </el-form>
      <div style="width:100%;margin: 0 auto;">
        <el-table :data="list" border style="width: 100%" :header-cell-style="{background:'#f5f5f5'}"
          v-loading="loading">
          <el-table-column label="学校名称" align="center">
            <template slot-scope="scope">
              <span @click="detail(scope.row)" style="cursor: pointer;color: #67C23A;text-decoration: underline;">
                {{scope.row.collegeName}}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="planned_number" label="计划数" align="center"></el-table-column>
          <el-table-column prop="collegeNature" label="院校性质" align="center">
          </el-table-column>
          <el-table-column prop="collegeAdmin" label="院校隶属" align="center">
          </el-table-column>
          <el-table-column prop="collegeType" label="院校类型" align="center">
          </el-table-column>
          <el-table-column prop="collegeProvince" label="所在省份" align="center">
          </el-table-column>
        </el-table>
      </div>
  </div>
  <div style="width: 100%;margin-top: 30px;display: flex;align-items: center;justify-content: center;">
      <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.page"
            :page-sizes="[20,100,200]"
            :page-size="form.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>

        <zhuanyeVue ref="zhuanyeData" />
    </div>
</el-dialog>
</template>

<script>
  import { majorCollege } from "@/api/gw/zonghe"
  import zhuanyeVue from "./zhuanye.vue"
  export default {
    components:{
      zhuanyeVue
    },
     data(){
      return{
        dialogVisible:false,
        form:{
          mojor_id:"",
          page:1,
          limit:20,
          collegeName:""
        },
        item:{},
        loading:false,
        total:0,
        list:[]
      }
     },
     methods:{
       show(item){
         this.$nextTick(()=>{
           this.item = item
           this.form["mojor_id"] = item.mojor_id
           this.dialogVisible = true
           this.majorCollege();
         })
       },
             //详情
      detail(item){
        this.$refs.zhuanyeData.show(item.recruitdata_id);
        //详情这里查询所有的专业
        //此时需要先判断是否登录，是否为VIP
        // this.$store.dispatch("isVipLogin").then(()=>{
        //     this.$router.push({
        //     path:"/SchoolDetail",
        //     query:{
        //       n:item.collegiate_id
        //     }
        //   })
        //   })
      },
       majorCollege(){
         this.loading = true
         majorCollege(this.form).then(res=>{
           this.total = res.data.total
           this.list = res.data.data
         }).finally(()=>{
          this.loading = false
         })
       },
       handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.limit = val;
      this.majorCollege();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.majorCollege();
    },
     },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/major/components/college.vue